// The page the user lands on after opening the app and without a session
export const FirstRunPage = 'TabsPage';

// The main page the user will see as they use the app over a long period of time.
// Change this if not using tabs
export const MainPage = 'ShopHomePage';

// The initial root pages for our tabs (remove if not using tabs)
export const Tab1Root = 'ShopHomePage';
export const Tab2Root = 'CategoriesPage';
export const Tab3Root = 'NotifyPage';
export const Tab4Root = 'CartPage';
export const Tab5Root = 'AccountPage';



// WEBPACK FOOTER //
// ./src/pages/index.ts